module.exports = __webpack_public_path__ + "static/media/edit _blues.96898c31.svg";